import React, { useEffect } from 'react';
import { useOrderManager } from './OrderManager';
import OrderSuccessModal from './OrderSuccessModal';

// This component renders the OrderSuccessModal inside the Router context
const OrderModalContainer = () => {
  const { showSuccessModal, setShowSuccessModal, orderData } = useOrderManager();

  // Force immediate rendering of the modal when it should be shown
  // This ensures there's no visible delay between cart modal closing and success modal showing
  useEffect(() => {
    // This effect runs on every render, ensuring the modal appears immediately
    // when showSuccessModal becomes true
    if (showSuccessModal) {
      // Make sure the modal is rendered in the next animation frame
      requestAnimationFrame(() => {
        const modalElement = document.querySelector('.order-success-modal');
        if (modalElement) {
          modalElement.style.opacity = '1';
        }
      });
    }
  }, [showSuccessModal]);

  return (
    <OrderSuccessModal 
      isOpen={showSuccessModal} 
      onClose={() => setShowSuccessModal(false)}
      orderItems={orderData?.originalItems || []}
      userSessionId={orderData?.userSessionId}
    />
  );
};

export default OrderModalContainer;
